// Canonical demo datasets (spec §9) — the same fixtures used across docs,
// landing pages, and (from Phase 3) the engine's unit tests. Phase 1 uses
// them only to pre-fill the input panes so the shell feels live.
export const DEMOS = {
  text: {
    lf: 'user-service.js (v1)',
    rf: 'user-service.js (v2)',
    left: `import { db } from "./db";

function loadUser(id) {
  return db.find(id);
}

function formatDate(d) {
  return d.toISOString();
}

function saveUser(user) {
  validate(user);
  log("saving");
  return db.save(user);
}`,
    right: `import { db } from "./db";

function loadUser(id) {
  return db.find(id);
}

function saveUser(user) {
  validate(user);
  return db.save(user);
}

function formatDate(d, tz) {
  return d.toLocaleString(tz);
}

export { loadUser, saveUser };`,
  },

  json: {
    lf: 'config.prod.json',
    rf: 'config.next.json',
    left: `{
  "version": "2.1",
  "debug": true,
  "db": { "host": "localhost", "timeout": 30, "pool": 5 },
  "cache": { "ttl": 300 }
}`,
    right: `{
  "db": { "timeout": 60, "host": "localhost" },
  "cache": { "ttl": 300 },
  "region": "ap-south-1",
  "version": 2.1
}`,
  },

  csv: {
    lf: 'customers_jan.csv',
    rf: 'customers_aug.csv',
    left: `id,name,plan,price
101,John,Pro,100
102,Sarah,Free,0
103,Mike,Pro,100
105,Priya,Team,150`,
    right: `id,name,plan,price
103,Mike,Pro,120
101,John,Enterprise,200
104,Alice,Free,0
105,Priya,Team,150`,
  },
};
